import { __awaiter } from "tslib";
import Vue from 'vue';
import apiKeysAhead from './components/ahead/index.vue';
import apiKeysItem from './components/item/index.vue';
import apiKeysAside from './components/aside/index.vue';
import { ApiKeysAsideModes, ServiceActionTypes, ApiKeyTypes } from '@/components/pages/apiKeysPage/interfaces/index';
import SERVICES from '@/constants/services';
import { ActivePopupTypes } from '@/store/modules/popup/types';
import { copyToClipboard } from '@/utils/other';
import { tryRefresh } from '@/services/_helpers/interceptors';
import { mapGetters } from 'vuex';
import _ from 'lodash';
let wss = null;
export default Vue.extend({
    name: 'apiKeysBody',
    data: () => ({
        searchField: '',
        asideMode: ApiKeysAsideModes.default,
        items: [],
        apiDeletingKeyID: null,
        loadError: false,
        isRetry: false,
        keysLeft: 0
    }),
    computed: Object.assign(Object.assign({}, mapGetters('user', ['getUserData'])), { isApiKeysUsing() {
            return !!_.get(this.getUserData.permissions.binance, 'apiKeys.create');
        },
        lkDisabled() {
            var _a, _b, _c;
            return ((_b = (_a = this.getUserData.docs) === null || _a === void 0 ? void 0 : _a.userUnsignedDocuments) === null || _b === void 0 ? void 0 : _b.length) && !((_c = this.getUserData.docs) === null || _c === void 0 ? void 0 : _c.docsPermission);
        },
        selectedItems() {
            const vm = this;
            return vm.items.filter((item) => item.selected);
        },
        showBody() {
            const vm = this;
            return vm.miw(641) || (vm.maw(641) && (vm.selectedItems.length <= 0 && vm.asideMode !== 'create'));
        },
        bodyColQuantity() {
            const vm = this;
            const fullWidth = vm.maw(769) && (vm.selectedItems.length <= 0 && vm.asideMode !== 'create');
            const cols = fullWidth ? 'col-12' : (vm.maw(960) ? 'col-7 ' : 'col-8');
            return cols;
        },
        showAside() {
            const vm = this;
            return vm.miw(769) || ((vm.selectedItems.length > 0 || vm.asideMode === 'create') && vm.maw(769));
        },
        asideColQuantity() {
            const vm = this;
            const fullWidth = vm.maw(641) && (vm.selectedItems.length > 0 || vm.asideMode === 'create');
            const cols = fullWidth ? 'col-12' : (vm.maw(960) ? 'col-5' : 'col-4');
            return cols;
        } }),
    watch: {
        selectedItems(newArr) {
            const vm = this;
            if (newArr.length) {
                vm.asideMode = ApiKeysAsideModes.default;
            }
        }
    },
    methods: {
        deselectAll() {
            const vm = this;
            vm.asideMode = 'default';
            vm.items.forEach((item) => { item.selected = false; });
        },
        handleClickOutside() {
            const vm = this;
            if (!vm.$store.getters['popupModule/getPopupIsOpened'] && vm.asideMode !== ApiKeysAsideModes.edit) {
                vm.items.forEach((item) => { item.selected = false; });
            }
        },
        handleSaveName(newName) {
            const vm = this;
            wss.send(JSON.stringify({
                action: ServiceActionTypes.changeApiName,
                payload: {
                    id: vm.selectedItems[0].id,
                    name: newName
                }
            }));
        },
        handleDeleteItem(payload) {
            wss.send(JSON.stringify({
                action: ServiceActionTypes.deleteApi,
                payload
            }));
            this.apiDeletingKeyID = payload.id;
        },
        handleSaveItem(payload) {
            const vm = this;
            const foundIndex = vm.items.findIndex((item) => item.id === payload.id);
            if (foundIndex < 0) {
                wss.send(JSON.stringify({
                    action: ServiceActionTypes.createApi,
                    payload
                }));
            }
            else {
                wss.send(JSON.stringify({
                    action: ServiceActionTypes.manegeApi,
                    payload
                }));
            }
        },
        handleClickAddKey() {
            const vm = this;
            vm.selectedItems.forEach((item) => {
                item.selected = false;
            });
            vm.asideMode = ApiKeysAsideModes.create;
        },
        handleClickEditKey() {
            const vm = this;
            vm.asideMode = ApiKeysAsideModes.edit;
        },
        handleKeyClick(id) {
            const vm = this;
            vm.items.forEach((item) => {
                if (item.id !== id) {
                    item.selected = false;
                }
                else
                    item.selected = !item.selected;
            });
        },
        handleCopyKey(id) {
            const vm = this;
            const removeFlagCopyFromAnotherItems = (copiedId) => {
                vm.items.forEach((item) => {
                    if (item.id !== copiedId)
                        item.copied = false;
                });
            };
            if (id) {
                const item = vm.items.find((item) => item.id === id);
                copyToClipboard(item.apiKey).then(() => {
                    item.copied = true;
                    removeFlagCopyFromAnotherItems(item.id);
                    setTimeout(() => { item.copied = false; }, 3000);
                });
            }
            else {
                vm.selectedItems.forEach((item) => {
                    copyToClipboard(item.apiKey).then(() => {
                        item.copied = true;
                        removeFlagCopyFromAnotherItems(item.id);
                        setTimeout(() => { item.copied = false; }, 3000);
                    });
                });
            }
        },
        errorMessageHandler(payload) {
            let error = '';
            if (Array.isArray(payload)) {
                error = payload.join('/n');
            }
            if (typeof payload === 'string') {
                error = payload;
            }
            return error;
        },
        init() {
            const vm = this;
            vm.loadError = false;
            vm.isRetry = true;
            if (Boolean(_.get(this.getUserData.permissions.binance, 'apiKeys.read')) === false) {
                vm.isRetry = false;
                return;
            }
            if (this.lkDisabled)
                return;
            wss = new WebSocket(`wss://${window.location.host}/ws/api_keys/`);
            wss.onopen = () => {
                setTimeout(() => {
                    wss.close();
                    wss = null;
                }, SERVICES.API_KEYS_RESET_TIMEOUT - 1000 * 60 * 1);
            };
            wss.onerror = () => {
                vm.loadError = true;
                vm.isRetry = false;
            };
            wss.onclose = function (event) {
                return __awaiter(this, void 0, void 0, function* () {
                    const refreshStatus = yield tryRefresh();
                    if (refreshStatus)
                        vm.init();
                });
            };
            wss.onmessage = (event) => {
                const data = JSON.parse(event.data);
                if (data.status === 401)
                    vm.$store.dispatch('user/loadUser');
                if (data.status >= 500 && data.status < 600) {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('apiKeysPage.alerts.titles.innerServerError'),
                        type: 'error',
                        autoDelete: true,
                        content: vm.$t('apiKeysPage.alerts.content.innerServerError')
                    });
                    vm.$store.commit('popupModule/setClosed');
                    vm.asideMode = ApiKeysAsideModes.default;
                }
                switch (data.action) {
                    case (ServiceActionTypes.apiKeys):
                        vm.loadError = false;
                        vm.isRetry = false;
                        vm.items = data.payload.map((item) => {
                            item.selected = false;
                            item.copied = false;
                            item.apiKey = item.api_key;
                            item.apiType = item.api_type;
                            item.itBuddyKey = item.api_type === ApiKeyTypes.buddy;
                            item.ips = !item.ips ? [] : item.ips.map((ipsItem) => {
                                ipsItem.copied = false;
                                ipsItem.isEditing = false;
                                return ipsItem;
                            });
                            delete item.api_key;
                            delete item.api_type;
                            delete item.secret;
                            return item;
                        });
                        break;
                    case (ServiceActionTypes.apiKeysLimit):
                        if (data.status === 200) {
                            vm.keysLeft = data.payload;
                        }
                        else if (data.status !== 100) {
                            vm.$store.dispatch('alertsBus/openAlert', {
                                title: vm.$t('apiKeysPage.alerts.titles.failedGetKeysQuantity'),
                                type: 'error',
                                autoDelete: true,
                                content: data.payload.join('/n')
                            });
                            vm.asideMode = ApiKeysAsideModes.default;
                        }
                        break;
                    case (ServiceActionTypes.createApi):
                        if (data.status === 201) {
                            vm.$store.dispatch('popupModule/openPopup', {
                                type: ActivePopupTypes.action,
                                letDefaultClose: true,
                                title: vm.$t('apiKeysPage.popups.titles.keySuccessfulCreated', { name: data.payload.name }),
                                content: '',
                                slot: {
                                    name: 'onCreateKeyPopupChunk',
                                    data: {
                                        api: data.payload.api_key,
                                        secret: data.payload.secret
                                    }
                                },
                                actions: [
                                    {
                                        title: vm.$t('apiKeysPage.popups.common.ok'),
                                        isAccent: true,
                                        callback() {
                                            vm.$store.commit('popupModule/setClosed');
                                        }
                                    }
                                ]
                            });
                            const truePayload = data.payload;
                            truePayload.selected = false;
                            truePayload.copied = false;
                            truePayload.apiKey = truePayload.api_key;
                            delete truePayload.api_key;
                            vm.items.push(truePayload);
                            vm.keysLeft--;
                            vm.asideMode = ApiKeysAsideModes.default;
                        }
                        else if (data.status !== 100) {
                            vm.$store.dispatch('alertsBus/openAlert', {
                                title: vm.$t('apiKeysPage.alerts.titles.failedCreateKey'),
                                type: 'error',
                                autoDelete: true,
                                content: this.errorMessageHandler(data.payload)
                            });
                            vm.$store.commit('popupModule/setClosed');
                            vm.asideMode = ApiKeysAsideModes.default;
                        }
                        break;
                    case (ServiceActionTypes.manegeApi):
                        if (data.status === 201) {
                            const truePayload = data.payload;
                            truePayload.selected = false;
                            truePayload.copied = false;
                            truePayload.apiKey = truePayload.api_key;
                            delete truePayload.api_key;
                            vm.items.splice(vm.items.findIndex((item) => item.id === truePayload.id), 1, truePayload);
                            vm.asideMode = ApiKeysAsideModes.default;
                            vm.$store.commit('popupModule/setClosed');
                            vm.$store.dispatch('alertsBus/openAlert', {
                                title: vm.$t('apiKeysPage.alerts.titles.success'),
                                type: 'success',
                                autoDelete: true,
                                content: vm.$t('apiKeysPage.alerts.content.keySettingsChanged')
                            });
                        }
                        else if (data.status !== 100) {
                            vm.$store.dispatch('alertsBus/openAlert', {
                                title: vm.$t('apiKeysPage.alerts.titles.failedApplyChanges'),
                                type: 'error',
                                autoDelete: true,
                                content: this.errorMessageHandler(data.payload)
                            });
                            vm.asideMode = ApiKeysAsideModes.default;
                            vm.$store.commit('popupModule/setClosed');
                        }
                        break;
                    case (ServiceActionTypes.deleteApi):
                        if (data.status === 204) {
                            vm.keysLeft++;
                            vm.asideMode = ApiKeysAsideModes.default;
                            vm.items.splice(vm.items.findIndex((item) => item.id === vm.apiDeletingKeyID), 1);
                            vm.$store.dispatch('alertsBus/openAlert', {
                                title: vm.$t('apiKeysPage.alerts.titles.success'),
                                type: 'success',
                                autoDelete: true,
                                content: vm.$t('apiKeysPage.alerts.content.keyDeleted')
                            });
                            vm.apiDeletingKeyID = null;
                            vm.$store.commit('popupModule/setClosed');
                        }
                        else if (data.status !== 100) {
                            vm.$store.dispatch('alertsBus/openAlert', {
                                title: vm.$t('apiKeysPage.alerts.titles.failedDeleteKey'),
                                type: 'error',
                                autoDelete: true,
                                content: this.errorMessageHandler(data.payload)
                            });
                            vm.apiDeletingKeyID = null;
                            vm.$store.commit('popupModule/setClosed');
                        }
                        break;
                    case (ServiceActionTypes.changeApiName):
                        if (data.status === 200) {
                            vm.items.find((item) => item.id === data.payload.id).name = data.payload.name;
                            vm.asideMode = ApiKeysAsideModes.default;
                        }
                        else if (data.status !== 100) {
                        }
                        break;
                    default:
                        break;
                }
            };
        }
    },
    created() {
        const vm = this;
        vm.init();
        const urlParams = new URLSearchParams(window.location.search);
        const createMode = urlParams.get('create-mode') === 'true';
        if (createMode) {
            vm.asideMode = ApiKeysAsideModes.create;
        }
    },
    beforeRouteLeave() {
        wss.close();
        wss = null;
    },
    components: {
        apiKeysAhead,
        apiKeysItem,
        apiKeysAside
    }
});
